<template>

    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'top' ,params: { brandPath: $route.params.brandPath}} ">TOPへ</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{menuNameUpper}}</p>
                    <p class="menu_center_tex_l">{{menuNameLower}}</p>
                </div>
                <div class="menu_right">
                    <a href="#" @click.prevent.stop="openModel(healthCheckData.healthCheckPage.manualFilePath,modal_type.manual)"><i class="far fa-question-circle"></i> マニュアル</a>
                </div>
            </div>
        </div>

        <div class="main_unit">
            <div class="top_unit">
                <div class="top_name_box">{{getStaffName}}<span class="mgl_24">{{registCount}}回目</span></div>
                <div class="top_center_box"> </div>
            </div>

            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="wd840">

                    <div class="error_text" v-if="validationMessage">
                        <Message :validationMessage="alertMessage" /><br>
                        <Message :validationMessage="validationMessage" />
                    </div>
                    <div class="check_midashinami_unit">
                      <div class="check_midashinami_box">
                        健康身だしなみ
                        <ul style="width: 760px;">
                          <li v-for="(Item, index) in healthData" :key="Item">
                            <div style="width: 100%">

                              <a href="#" role="button" v-if="Item['status'] == 0" @click.prevent.stop="icnClick('status',0,index)">
                                <img v-if="Item['healthCheckItemNo'] >= 1 && Item['healthCheckItemNo'] <= 10" :src="Item['icn']" :alt="Item['healthCheckItemName']"><div v-else ></div><br><p>{{Item['healthCheckItemName']}}</p></a>
                              <a href="#" class="icn_hover_Ok" role="button" v-else-if="Item['status'] == 1 && !Item['disabled']"
                                 @click.prevent.stop="icnClick('status',1,index)"><img v-if="Item['healthCheckItemNo'] >= 1 && Item['healthCheckItemNo'] <= 10" :src="Item['hv_icn']" class="active" :alt="Item['healthCheckItemName']"><div v-else ></div><br><p>{{Item['healthCheckItemName']}}</p></a>
                              <a class="icn_hover_Ok" role="button" v-else-if="Item['status'] == 1 && Item[5]['disabled']"
                                 disabled="true"><img v-if="Item['healthCheckItemNo'] >= 1 && Item['healthCheckItemNo'] <= 10" :src="Item['hv_icn']" class="active" :alt="Item['healthCheckItemName']"><div v-else ></div><br><p>{{Item['healthCheckItemName']}}</p></a>
                              <a href="#" class="icn_hover_Ng" role="button" v-else-if="Item['status'] == 2 && !Item['disabled']"
                                 @click.prevent.stop="icnClick('status',2,index)"><img v-if="Item['healthCheckItemNo'] >= 1 && Item['healthCheckItemNo'] <= 10" :src="Item['hv_icn']" class="active icn_hover_Ng" :alt="Item['healthCheckItemName']"><div v-else ></div><br><p>{{Item['healthCheckItemName']}}</p></a>
                              <a class="icn_hover_Ng" role="button" v-else-if="Item['status'] == 2 && Item['disabled']"
                                 disabled="true"><img v-if="Item['healthCheckItemNo'] >= 1 && Item['healthCheckItemNo'] <= 10" :src="Item['hv_icn']" class="active icn_hover_Ng" :alt="Item['healthCheckItemName']"><div v-else ></div><br><p>{{Item['healthCheckItemName']}}</p></a>

                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="textarea_unit wd840 mgt_20">
                        <textarea v-model="comment" class="textarea_box" placeholder="連絡事項 / 改善措置 / コメントを入力" maxlength="200"></textarea>
                        <div class="right_icn1">
                            <a href="#">
                                <p class="icn_red" @click.prevent.stop="openModel(healthCheckData.healthCheckPage.informationFilePath,modal_type.info)"><i class="fas fa-info-circle"></i></p>
                            </a>
                        </div>
                    </div>
                    <div class="btn_submit letter_spa">
                        <a href="#" role="button" @click.prevent.stop="sendChechInput()" >登録</a>
                    </div>
                </div>
            </div>

            <div class="overlay" v-show="showContent">
                <div >
                    <div class="modal_box wd975_d">
                        <div class="modal_header_unit">
                            <div class="modal_header_box">
                                <p class="modal_header_tit_s"> </p>
                                <p class="modal_header_tit" >{{ modal_title }}</p>
                            </div>
                            <div class="modal_header_left">
                                <a class="js-modal-close" role="button" @click.prevent.stop="closeModel">閉じる</a>
                            </div>
                        </div>
                        <div v-if="fileFormat=='pdf' && pages!==0" class="modal_content_tex2 image_background_color modal_content_pdf">
                            <div class="modal_content_box2">
                                <div class="pdf-container image_background_color">
                                    <canvas v-for="page in pages" :id="'canvas' + page" :key="page" class="planCanvas" oncontextmenu="return false;"
                                            height="100%" width="100%" style="height: 100%; width: 100%;"></canvas>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="fileFormat=='img'" class="modal_content_tex2">
                            <div class="modal_content_box2">
                                <img class="modal_img" :src="modal_image_file_path">
                            </div>
                        </div>
                        <div v-else class="modal_content_tex2">
                            <div class="modal_content_box2">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay" v-show="showContent2">
                <div>
                    <div class="modal_box wd512">
                        <div class="modal_header_unit">
                            <div class="modal_header_box">
                                <p class="modal_header_tit_s">{{menuNameUpper}}</p>
                                <p class="modal_header_tit">{{menuNameLower}}</p>
                            </div>
                        </div>
                        <div class="modal_content_tex">
                            <p>{{menuNameLower}}<br>
                                が完了しました。</p>
                            ※5秒後に自動でTOPに戻ります。<br>
                            ※未入力がある場合は、再度入力してください。
                        </div>

                        <div class="btn_submit">
                            <a @click.prevent.stop="closeModalTop">TOPに戻る</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overlay_loder" v-show="isLoading">
                <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    import PDF from 'pdfjs-dist'
    import PDFJSWorker from '!!file-loader!pdfjs-dist/build/pdf.worker.min.js';
    PDF.GlobalWorkerOptions.workerSrc = PDFJSWorker;

    export default {
        name: 'HealthCheck',
        components: {
            PulseLoader,
            Message
        },
        props:{
            menuNameUpper:String,
            menuNameLower:String,
        },
        computed:{
            getStaffName:function () {
                return  this.$store.getters['staff/name'];
            },
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
        },
        data() {
            return {
                pages: 0,
                fileFormat:"",
                isLoading: false,
                isInitLoading:true,
                showContent: false,
                showContent2:false,
                comment:null,
                validationMessage:'',
                time:5,
                timer:false,
                healthData:[
                    { "status": 0, "healthCheckItemId": 1, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 2, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 3, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 4, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 5, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 6, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 7, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 8, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 9, "healthCheckItemName": "", "disabled": false },
                    { "status": 0, "healthCheckItemId": 10,"healthCheckItemName": "",  "disabled": false}
                    ],
                modal_image_file_path:"",
                healthCheckData: {
                    "topButtonId": null,
                    "healthCheckPage":
                        { "topButtonId": null,
                            "healthCheckPageId": null,
                            "manualFilePath": "",
                            "informationFilePath": null,
                            "staffId": "",
                            "staffName": ""
                        },
                    "healthCheckHistory": [
                        { "healthCheckItemId": null, "healthCheckItemNo": null, "healthCheckItemName": "" },
                    ],
                    "healthCheckComment": null,
                    "registCount": null
                },
                alertMessage:'入力エラーがあります。',
                modal_title:"",
                modal_type : {
                    manual: "マニュアル",
                    info: "インフォメーション"
                }
            }
        },
        created: function(){
            this.calc();
        },
        methods: {
            async calc() {

                this.isInitLoading = true;
                var apiResponseFlg = true;

                //健康・手洗い・身だしなみチェック内容取得API
                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var pkStaffId = this.$store.getters['staff/id'];
                var topButtonId = this.$route.params.menuId;
                var datetime = this.dateFormat2();

                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/top/' + topButtonId + '/store/' + storeId + '/staff/' + pkStaffId + '?date=' + datetime;

                await this.$axios
                    .get(url)
                    .then(response => (this.healthCheckData = response.data))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);

                // APIエラーの場青、処理終了
                if(!apiResponseFlg){
                    //処理終了
                    return null;
                }

                //画面の初期処理に呼び出す
                let itemList = [];
                this.healthData = [];
                for (var i = 0; i < this.healthCheckData.healthCheckHistory.length; i++) {
                    if(this.healthCheckData.healthCheckHistory[i].healthCheckItemNo == 5) {
                      continue;
                    }
                    // 非表示対象の場合、リクエスト対象から除外する
                    if(this.healthCheckData.itemHideFlg && (this.healthCheckData.healthCheckHistory[i].healthCheckItemNo == 1 || this.healthCheckData.healthCheckHistory[i].healthCheckItemNo == 2 || this.healthCheckData.healthCheckHistory[i].healthCheckItemNo == 7)){
                      // 次の処理へ
                      continue;
                    }
                    var indexList = new Object();
                    if (this.healthCheckData.healthCheckHistory[i].status == 1 || this.healthCheckData.healthCheckHistory[i].status == 2) {
                        indexList['status'] = this.healthCheckData.healthCheckHistory[i].status;
                        indexList['healthCheckItemId'] = this.healthCheckData.healthCheckHistory[i].healthCheckItemId;
                        indexList['healthCheckItemNo'] = this.healthCheckData.healthCheckHistory[i].healthCheckItemNo;
                        indexList['healthCheckItemName'] = this.healthCheckData.healthCheckHistory[i].healthCheckItemName;
                        indexList["disabled"] = true;
                        indexList["itemNo"] = this.healthCheckData.healthCheckHistory[i].healthCheckItemNo;
                        indexList["icn"] = this.getIcon(this.healthCheckData.healthCheckHistory[i].healthCheckItemNo);
                        indexList["hv_icn"] = this.getHvIcon(this.healthCheckData.healthCheckHistory[i].healthCheckItemNo);
                    } else {
                        indexList['status'] = 0;
                        indexList['healthCheckItemId'] = this.healthCheckData.healthCheckHistory[i].healthCheckItemId;
                        indexList['healthCheckItemNo'] = this.healthCheckData.healthCheckHistory[i].healthCheckItemNo;
                        indexList['healthCheckItemName'] = this.healthCheckData.healthCheckHistory[i].healthCheckItemName;
                        indexList["disabled"] = false;
                        indexList["itemNo"] = this.healthCheckData.healthCheckHistory[i].healthCheckItemNo;
                        indexList["icn"] = this.getIcon(this.healthCheckData.healthCheckHistory[i].healthCheckItemNo);
                        indexList["hv_icn"] = this.getHvIcon(this.healthCheckData.healthCheckHistory[i].healthCheckItemNo);
                    }
                    itemList.push(indexList);
                }

                this.healthData = itemList;

                if(this.healthCheckData.healthCheckComment !== null){
                    this.comment = this.healthCheckData.healthCheckComment.comment;
                }

                this.registCount = this.healthCheckData.registCount
            },
            openModel(value,title) {

                // 拡張子の格納
                if(value !== null && value !== ""){
                    var length = value.length;
                    var searchStrStart = value.lastIndexOf(".",length) ;
                    var searchStrEnd = value.lastIndexOf("?",length) ;
                    var fileFormatStr = value.slice(searchStrStart,searchStrEnd)
                    this.fileFormat = fileFormatStr.replace("?","").replace(".","");
                }

                // PDFと画像の処理判定
                if(this.fileFormat == 'pdf'){
                    // PDF
                    let loadingTask = PDF.getDocument(value);
                    loadingTask.promise.then(pdf => {
                        this.pdfDoc = pdf;
                        this.pages = this.pdfDoc.numPages;
                        this.$nextTick(() => {
                            this.renderPage(1);
                        });
                    }).catch(() => {
                        let error = {
                            button: {
                                path: {name: 'top', params: {brandPath: this.brandPath}}
                            },
                            'message': 'PFDファイルの描画に失敗しました。'
                        };
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isInitLoading = false);

                }
                else if(this.fileFormat !== ""){
                    // 画像表示時
                    this.modal_image_file_path = value;
                    this.fileFormat = "img";
                }
                else{
                    // ファイル未設定
                    this.modal_image_file_path = "";
                    this.fileFormat = "";
                }

                this.modal_title = title;
                this.modal_image_file_path = value;
                this.showContent = true;
            },
            renderPage (num) {
                this.pdfDoc.getPage(num).then(page => {
                    // 描画処理
                    let canvas = document.getElementById("canvas" + num);
                    let viewport = page.getViewport({ scale: 0.5, });
                    let desiredWidth = canvas.parentElement.clientWidth;
                    let scale = desiredWidth / viewport.width;
                    let scaledViewport = page.getViewport({ scale: scale, });

                    let ctx = canvas.getContext('2d');
                    canvas.height = scaledViewport.height;
                    canvas.width = scaledViewport.width;

                    let renderContext = {
                        canvasContext: ctx,
                        viewport: scaledViewport
                    };
                    //PDFに複数のページがある場合、複数回レンダリングする
                    page.render(renderContext);
                    if (this.pages > num) {
                        this.renderPage(num + 1);
                    }
                });
            },
            closeModel() {
                this.showContent = false;
            },
            image_path(imgpath) {
                return require(imgpath);
            },
            setStyle(obj, coler) {
                obj['bg_clore'] = coler;
            },
            setRedColor: function (obj, color) {
                obj['bg_color'] = color;
            },
            closeModalTop(){
                clearInterval(this.timer);
                this.timer = 0;
                //topへ遷移
                this.$router.push({name: 'top', params: { brandPath: this.$route.params.brandPath}});
            },
            icnClick:function(id, statusValue, item_no) {

                var buttonCheckList = this.healthData[item_no];
                var value = 0;
                switch (statusValue) {
                    case 0:
                        value = 1;
                        break;
                    case 1:
                        value = 2;
                        break;
                    case 2:
                        value = 1;
                        break;
                }

                buttonCheckList[id] = value;
                buttonCheckList["disabled"] = false;
                this.healthData.splice(item_no,1,buttonCheckList);
            },
            async sendChechInput() {

                this.isLoading = true;

                //バリデーションフラグ
                var validationFlg = true;
                //バリデーションチェック(桁数)
                this.validationMessage = '';

                var apiResponseFlg = true;

                if(String(this.comment).length > 200){
                    this.validationMessage="コメントは200文字以下で入力してください。"
                    validationFlg = false;
                    this.scrollTop();
                }

                if(!validationFlg){
                    this.isLoading = false;
                    //処理終了
                    return null;
                }

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var pkStaffId = this.$store.getters['staff/id'];
                var healthCheckPageId = this.healthCheckData.healthCheckPage.healthCheckPageId;
                var date = this.dateFormat();
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/staff/' + pkStaffId + '/health_check/' + healthCheckPageId + '?date=' + date;

                //リクエストデータ生成
                var healthDataPostList = [];
                for(var k =0 ; k < this.healthData.length ; k++){
                    if(this.healthData[k]['itemNo'] == 5){
                        continue;
                    }
                    // 非表示対象の場合、リクエスト対象から除外する
                    if(this.healthCheckData.itemHideFlg && (this.healthData[k]['itemNo'] == 1 || this.healthData[k]['itemNo'] == 2 || this.healthData[k]['itemNo'] == 7)){
                        // 次の処理へ
                        continue;
                    }

                    var healthDataObj2 = new Object();
                    healthDataObj2['status'] = this.healthData[k]['status']
                    healthDataObj2['health_check_item_id'] = this.healthData[k]['healthCheckItemId']
                    healthDataPostList.push(healthDataObj2);
                }

                var healthDataPostCommnet=  new Object();
                healthDataPostCommnet['comment'] = this.comment;

                //更新API呼び出し
                await this.$axios
                    .post(url, {health_check_page_id:healthCheckPageId,healthCheckHistory:healthDataPostList,healthCheckComment:healthDataPostCommnet})
                    .then()
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        apiResponseFlg = false;
                        if (err.customError) {
                            error = Object.assign(error, err.customError);

                            if(error.code == 400){
                                this.validationMessage =  error.message;
                                this.scrollTop();
                            }
                        }
                        if(error.code !== 400){
                            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                        }
                    }).finally(()=> this.isLoading = false);

                // 処理エラーがない場合
                if(apiResponseFlg){
                    this.isLoading = false
                    this.showContent2 = true;
                    //５秒後にTOPへ遷移する
                    this.startTimer();
                }

            },
            dateFormat(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);

                let format_str = 'YYYYMMDD'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                return format_str;
            },
            dateFormat2(){
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            },
            startTimer:function(){
                this.time = 5;
                this.stopTImer();
                this.timer = setInterval(() => this.countdown(),1000);
            },
            //タイマー設定
            stopTImer:function(){
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer = 0;
                }
            },
            countdown:function () {
                if(this.time > 0){
                    this.time--;
                }
                else{
                    clearInterval(this.timer);
                    this.timer = 0;
                    this.closeModalTop();
                }
            },
            destoryed(){
                this.stopTImer();
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            getIcon(itemNo) {
              switch (itemNo) {
                case 1: return require('@/app/assets/img/icn_check_roller.png');
                case 2: return require('@/app/assets/img/icn_check_tearai.png');
                case 3: return require('@/app/assets/img/icn_check_taichou.png');
                case 4: return require('@/app/assets/img/icn_check_kizu.png');
                case 5: return require('@/app/assets/img/icn_check_kenben.png');
                case 6: return require('@/app/assets/img/icn_check_chakui.png');
                case 7: return require('@/app/assets/img/icn_check_kutsu.png');
                case 8: return require('@/app/assets/img/icn_check_tsumekiri.png');
                case 9: return require('@/app/assets/img/icn_check_accse.png');
                case 10: return require('@/app/assets/img/icn_check_touhatsu.png');
              }
            },
            getHvIcon(itemNo) {
              switch (itemNo) {
                case 1: return require('@/app/assets/img/icn_check_hv_roller.png');
                case 2: return require('@/app/assets/img/icn_check_hv_tearai.png');
                case 3: return require('@/app/assets/img/icn_check_hv_taichou.png');
                case 4: return require('@/app/assets/img/icn_check_hv_kizu.png');
                case 5: return require('@/app/assets/img/icn_check_hv_kenben.png');
                case 6: return require('@/app/assets/img/icn_check_hv_chakui.png');
                case 7: return require('@/app/assets/img/icn_check_hv_kutsu.png');
                case 8: return require('@/app/assets/img/icn_check_hv_tsumekiri.png');
                case 9: return require('@/app/assets/img/icn_check_hv_accse.png');
                case 10: return require('@/app/assets/img/icn_check_hv_touhatsu.png');
              }
            }
        }
    }
</script>
